import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PartiesList } from '@/components/parties/PartiesList';
export function PartiesPage() {
    return (_jsxs("div", { style: { maxWidth: '800px', margin: '0 auto', padding: '24px 16px' }, children: [_jsx("h1", { style: {
                    fontFamily: 'var(--font-family-heading)',
                    fontSize: 'clamp(1.25rem, 3vw, 1.75rem)',
                    fontWeight: 700,
                    color: 'var(--color-text)',
                    marginBottom: '32px',
                }, children: "Parties" }), _jsx(PartiesList, {})] }));
}
